import ExternalModal from './ExternalModal';

export default ExternalModal;
